/**
 * How a section is named next to its class. A section without a name is the whole class taught as
 * one group ("Terminale OSE"), so the class name alone is shown. Keep in sync with
 * backend Section::displayName().
 */
export function sectionLabel(
  className: string | null | undefined,
  sectionName: string | null | undefined,
  separator = ' ',
): string {
  const cls = (className ?? '').trim()
  const section = (sectionName ?? '').trim()
  if (!section) return cls
  return cls ? `${cls}${separator}${section}` : section
}

/** True for the unnamed section of a class taught as one group. */
export function isWholeClassSection(sectionName: string | null | undefined): boolean {
  return !(sectionName ?? '').trim()
}
